/**
 * @file Color input type - color picker with hex input and palette support
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const ColorInputType = {
  name: 'color',
  matches: getAttribute => getAttribute('format') === 'color',
  displayComponent: {
    name: 'ColorDisplay',
    props: ['value', 'getAttribute'],
    computed: {
      formattedValue() {
        if (!this.value) return '';
        return this.value.toUpperCase();
      },
    },
    template: `
      <div
        class="border rounded"
        :style="{
          width: '24px',
          height: '24px',
          backgroundColor: value || '#ffffff',
          border: '1px solid #dee2e6'
        }"
        :title="value || ''"
      ></div>
    `,
  },
  editComponent: {
    name: 'ColorEdit',
    props: ['value', 'getAttribute', 'validationError'],
    emits: ['input', 'keydown', 'blur'],
    methods: {
      parseInputValue(event) {
        const inputValue = event.target.value;
        if (!inputValue) return undefined;
        return inputValue.toUpperCase();
      },
      handleInput(event) {
        const parsedValue = this.parseInputValue(event);
        this.$emit('input', { target: { value: parsedValue } });
      },
      handleColorSelect(color) {
        this.$emit('input', { target: { value: color } });
      },
    },
    template: `
      <div class="d-flex flex-wrap gap-1 align-items-center">
        <!-- Color input -->
        <div class="d-flex gap-1">
          <input
            type="color"
            class="form-control form-control-color"
            :class="{ 'is-invalid': validationError }"
            :value="value || '#000000'"
            @input="handleInput"
            style="width: 40px; height: 32px;"
          />

          <!-- Hex input -->
          <input
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': validationError }"
            :value="value || ''"
            placeholder="#RRGGBB"
            maxlength="7"
            style="width: 80px;"
            @input="handleInput"
            @keydown="$emit('keydown', $event)"
          />
        </div>

        <!-- Color palette if defined -->
        <div
          v-for="color in getAttribute('enum', [])"
          :key="color"
          class="border rounded"
          :style="{
            width: '24px',
            height: '24px',
            backgroundColor: color,
            border: value === color ? '2px solid #0d6efd' : '1px solid #dee2e6',
            cursor: 'pointer'
          }"
          :title="color"
          @click="handleColorSelect(color)"
        ></div>
      </div>
    `,
  },
};

export default ColorInputType;
